import { combineReducers } from "redux"

import menu from "./menu"
import snackbar from "./snackbar"

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({
    menu,
    snackbar,
})

export default reducers
